import { render, staticRenderFns } from "./DataJobDetailModal.vue?vue&type=template&id=e18f57bc"
import script from "./DataJobDetailModal.vue?vue&type=script&lang=js"
export * from "./DataJobDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports